// extracted by mini-css-extract-plugin
export default {"columns":"AnonymousDialog-columns_H6tzx","switch":"AnonymousDialog-switch_OYBvb"};